import * as Tone from 'tone'
import { InstrumentBase } from './InstrumentBase';
import { getAudioGraphInstance } from '../audioEngine';
import { Piano as TonePiano } from '@tonejs/piano'
import { PianoUI } from "../projectViews/stationViews/PianoUI";
import units from "../units.json"
import { addKeysAsField } from '../utils/misc';
import { limitToNyquist } from '../utils/parameters';
import colors from "../../styles/colors.module.scss";
import { PianoRoller } from './PianoRoller';

export class Piano extends InstrumentBase {
    static metadata = {
        tipus: 'piano',
        tipusDisplay: 'Piano Legacy',
        versio: '0.1',
        color: colors.orange,
        hasLogo: true,
        hasMiniature: true,
    }
    static parametersDescription = addKeysAsField({
        ...super.parametersDescription,
        ...PianoRoller.parametersDescription,
        timbre: {type: 'float', unit: units.hertz, min: 1200, max: 12000, initial: 12000, logarithmic: true, bind: "preset"},
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        typical: {min: 48, max: 71}
    }

    getUserInterfaceComponent() {
        return PianoUI
    }

    async buildInstrumentAudioGraph() {
        await super.buildInstrumentAudioGraph();
        // Creem els nodes del graph i els guardem
        const timbre = new Tone.Filter(500, 'lowpass', -12);
        const gainFixPiano = new Tone.Gain(Tone.dbToGain(-20)).connect(timbre);
        const piano = new TonePiano({velocities:4, maxPolyphony: this.constructor.maxPolyphony, url:appPrefix + "/static/dist/public/audio/piano/"}).connect(gainFixPiano);
        piano.load().then(() => { console.debug('Mostres del piano carregades!') })

        this.audioNodes = {
            piano: piano,
            timbre: timbre,
            gainFixPiano: gainFixPiano,
        };

        // Crea els nodes d'efectes (això també els afegirà al diccionari de nodes de l'instrument)
        this.addEffectChainNodes(timbre, this.bus);
    }

    setParameterInAudioGraph(name, value) {
        if (name == "timbre") {
            this.audioNodes.timbre.frequency.rampTo(limitToNyquist(value), 0.01);
        }
    }

    onSequencerStep(currentMainSequencerStep, time) {
        if (this.getPlaybackParameterValue("clipNumber") === undefined) return;
        // Iterate over all the notes in the sequence and trigger those that start in the current beat (step)
        const currentStep = currentMainSequencerStep % this.getPlaybackClip().length;
        const sequence = this.getPlaybackClip().sequence;
        for (let i = 0; i < sequence.length; i++) {
            const note = sequence[i];
            if (note.onset === currentStep) {
                const duration = Math.min(note.onset + note.duration, this.getPlaybackClip().length) - note.onset;
                this.audioNodes.piano.keyDown({note:Tone.Frequency(note.pitch, "midi").toNote(), velocity:(note.velocity ?? 127) / 127, time:time})
                this.audioNodes.piano.keyUp({note:Tone.Frequency(note.pitch, "midi").toNote(), time:time + duration * getAudioGraphInstance().get16BeatTime()})
            }
        }
    }

    onTransportStop() {
        // Stop all notes that are still playing
        this.audioNodes.piano.stopAll()
    }

    onStopAllSounds() {
        // Stop all notes that are still playing
        this.audioNodes.piano.stopAll()
    }

    onMidiNote(pitch, midiVelocity, noteOff, extras) {
        if (!getAudioGraphInstance().isGraphBuilt()) return;

        if (!noteOff) this.audioNodes.piano.keyDown({note:Tone.Frequency(pitch, "midi").toNote(), velocity:midiVelocity/127});
        else this.audioNodes.piano.keyUp({note:Tone.Frequency(pitch, "midi").toNote()});
        
        if (!extras.skipRecording) this.handlePianoRollRecording(pitch, midiVelocity, noteOff);
    }
}
